import React from 'react';

/** Represents a Tag icon used on the Collection Block title */
export const IconTag = (props: React.SVGAttributes<SVGSVGElement>): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          stroke="currentColor"
          strokeWidth="3"
          d="M23.18 1.5c4.033 0 5.517.367 6.997 1.158a7.607 7.607 0 0 1 3.165 3.165c.791 1.48 1.158 2.964 1.158 6.996v10.362c0 4.032-.367 5.516-1.158 6.996a7.607 7.607 0 0 1-3.165 3.165c-1.48.791-2.964 1.158-6.996 1.158H12.819c-4.032 0-5.516-.367-6.996-1.158a7.607 7.607 0 0 1-3.165-3.165C1.867 28.697 1.5 27.213 1.5 23.18V12.819c0-4.032.367-5.516 1.158-6.996a7.607 7.607 0 0 1 3.165-3.165C7.303 1.867 8.787 1.5 12.82 1.5Z"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M19.159 10.413a4.869 4.869 0 0 0-3.686-1.407l-3.853.2a2.543 2.543 0 0 0-2.413 2.414l-.201 3.853a4.869 4.869 0 0 0 1.407 3.686l7.003 7.003c.537.536 1.24.838 2.01.838.771 0 1.475-.302 2.011-.838l4.725-4.725c.536-.536.838-1.24.838-2.01 0-.77-.302-1.474-.837-2.01l-7.004-7.004Zm-6.214 4.642a1.474 1.474 0 0 1 0-2.11 1.466 1.466 0 0 1 1.039-.445c.371 0 .741.148 1.039.444.63.593.63 1.556.036 2.111a1.479 1.479 0 0 1-2.114 0Z"
        />
      </g>
    </svg>
  );
};
